* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.grid-view {
  height: 400px;
}
